
import { Prop, Component, Vue } from 'nuxt-property-decorator';
import { Context } from '@nuxt/types';
import { TranslateResult } from 'vue-i18n';
import WatchVideoDialog from '~/components/Sanity/WatchVideoDialog.vue';
import { MuxStreamTypes } from '~/types/mux-player';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import VideoPlayerMinimal from '../UIComponents/VideoPlayerMinimal.vue';
import VideoPlayer from '../Player/VideoPlayer.vue';

const schema = SanityDocumentSchema.PROJECT;

interface ITrailerTab {
  name: string;
  text: TranslateResult;
}

@Component({
  components: {
    WatchVideoDialog,
    VideoPlayerMinimal,
    VideoPlayer,
  },
})
export default class RZRTrailerTakeover extends Vue {
  @Prop(String) readonly projectSlug!: string;

  docType = SanityDocumentSchema.VIDEO;
  muxStreamType = MuxStreamTypes.ON_DEMAND;

  activeTab: string = 'watch';

  tabs: ITrailerTab[] = [
    { name: 'watch', text: this.$t('common.misc.watch') },
    { name: 'unlock', text: this.$t('common.misc.unlock') },
    { name: 'own', text: this.$t('common.misc.own') },
  ];

  async fetch() {
    await this.$sanityLookup.fetchDocument({
      _type: schema,
      slug: this.projectSlug,
    });

    await this.$sanityLookup.fetchDocument({
      _type: this.docType,
      _id: this.project?.trailer?._ref,
    });
  }

  get pageState() {
    return (
      this.$sanityLookup.getDocumentFromSlug({
        _type: schema,
        slug: this.projectSlug,
      }) || {
        isLoading: false,
        hasError: false,
      }
    );
  }

  get trailerDoc() {
    if (!this.trailerId) {
      return;
    }

    return this.$sanityLookup.getDocumentFromId({
      _id: this.trailerId,
      _type: this.docType,
    })?.data;
  }

  get project() {
    return this.pageState?.data;
  }

  get isLoading() {
    return this.pageState?.isLoading;
  }

  get hasError() {
    return this.pageState?.hasError;
  }

  get heroImage() {
    if (!this.project?.pageHeroImage) {
      return;
    }

    const imageSource = {
      asset: this.project.pageHeroImage.asset,
    };

    return imageSource;
  }

  get posterImageUrl() {
    if (!this.project?.pageHeroImage) {
      return undefined;
    }

    const w = 1920;
    const h = (w * 9) / 16;
    return this.$sanityImage
      .urlFor(this.project?.pageHeroImage)
      .width(w)
      .height(h)
      .fit('crop')
      .url();
  }

  get trailerId() {
    return this.project?.trailer?._ref;
  }

  get logo() {
    if (!this.project?.logo) {
      return;
    }

    return this.$sanityImage.urlFor(this.project.logo).url();
  }

  get title() {
    return this.project?.title || '';
  }
}
